import {useIntl} from 'react-intl'
import {CrudProvider} from '../../../../../services/loggedin/CrudContext'
import {FormComponent} from '../../../../parts/crud/Form'
import clsx from 'clsx'
import { LinkedList } from '../../../../parts/components/LinkedList'

export const ServerGroupForm = () => {
  const intl = useIntl()
  return (
    <>
      <CrudProvider api='system-settings/server-groups'>
        <FormComponent
          fetch={{
            servers: 'system-settings/server-groups/server-names',
          }}
          redirect='/system-settings/server-groups'
          text_modificato={intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVER_GROUP.ADDED'})}
          text_nuovo={intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVER_GROUP.EDITED'})}
        >
          {(formik, data, remoteErrors, isEdit, otherError, item) => (
            <>
              <div className='row mb-6'>
                <div className='col-md-12'>
                  <label htmlFor='group_name' className='required fw-bold fs-6'>
                    {intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVER_GROUP.SERVER_GROUP_NAME'})}
                  </label>
                </div>
                <div className='col-md-12'>
                  <input
                    type='text'
                    className={clsx('form-control', {
                      'is-invalid':
                        (formik.touched.group_name && formik.errors.group_name) ||
                        remoteErrors.group_name !== undefined,
                      'is-valid':
                        formik.touched.group_name &&
                        !formik.errors.group_name &&
                        remoteErrors.group_name === undefined,
                    })}
                    id='group_name'
                    name='group_name'
                    onChange={formik.handleChange}
                    value={formik.values.group_name}
                  />
                  {formik.touched.group_name && formik.errors.group_name ? (
                    <em className='text-danger'>
        
                      {intl.formatMessage(
                        {id: formik.errors.group_name},
                        {
                          field: intl.formatMessage({
                            id: 'SYSTEM_SETTINGS.SERVER_GROUP.SERVER_GROUP_NAME',
                          }),
                        }
                      )}
                    </em>
                  ) : null}
                </div>
              </div>

              <div className='row mb-6'>
                <div className='col-md-12'>
                  <label htmlFor='group_description' className='required fw-bold fs-6'>
                    {intl.formatMessage({
                      id: 'SYSTEM_SETTINGS.SERVER_GROUP.SERVER_GROUP_DESCRIPTION',
                    })}
                  </label>
                </div>
                <div className='col-md-12'>
                  <input
                    type='text'
                    className={clsx('form-control', {
                      'is-invalid':
                        (formik.touched.group_description && formik.errors.group_description) ||
                        remoteErrors.group_description !== undefined,
                      'is-valid':
                        formik.touched.group_description &&
                        !formik.errors.group_description &&
                        remoteErrors.group_description === undefined,
                    })}
                    id='group_description'
                    name='group_description'
                    onChange={formik.handleChange}
                    value={formik.values.group_description}
                  />
                  {formik.touched.group_description && formik.errors.group_description ? (
                    <em className='text-danger'>
                      {intl.formatMessage(
                        {id: formik.errors.group_description},
                        {
                          field: intl.formatMessage({
                            id: 'SYSTEM_SETTINGS.SERVER_GROUP.SERVER_GROUP_DESCRIPTION',
                          }),
                        }
                      )}
                    </em>
                  ) : null}
                </div>
              </div>

              <div className='row mb-6'>

                <div className='col-md-12'>
                 <div className='col-md-12'>
                  <label htmlFor='group_name' className='required fw-bold fs-6'>
                    {intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVER_GROUP.ASSOCIATED_SERVERS'})}
                  </label>
                </div>
                  <LinkedList
                    is_valid={formik.touched.servers && !formik.errors.servers}
                    is_invalid={formik.touched.servers && formik.errors.servers}
                    datalist_a={data.servers}
                    datalist_b={formik.values.servers}
 
                    onChange={(servers: any) => {
                      formik.setFieldValue('servers', servers)
                    }}
                    itemFilter={(item: any, search: string) => {
    
                      if (search === '') {
                        return true
                      }
                      return (
                        item.server_name.toLowerCase().includes(search.toLowerCase()) ||
                        item.server_code?.toLowerCase().includes(search.toLowerCase())
                      )
                    }}
                  
                  >
                    {(item: any, index: number, list: string) => (
                      <>
                       
                           {item.server_name} [{item.server_code}]
                       
                      </>
                    )}
                  </LinkedList>

                  {formik.touched.servers && formik.errors.servers ? (
                      <em className='text-danger'> {intl.formatMessage(
                        {id: formik.errors.servers},
                        {
                          field: intl.formatMessage({
                            id: 'SYSTEM_SETTINGS.SERVER_GROUP.ASSOCIATED_SERVERS',
                          }),
                        }
                      )}</em>
                    ) : null}
                </div>
              </div>
            </>
          )}
        </FormComponent>
      </CrudProvider>
    </>
  )
}
